import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Icon } from '@scentregroup/ui'
import analyticsUtils from '../../../../helpers/analytics-utils'
import style from './index.scss'

const Pagination = ({
  totalItems,
  page,
  totalPages,
  className,
  filterState,
  buildUrl,
}) => {
  const lastPage = page + 1 >= totalPages
  const firstPage = page === 0
  // The page number in the URL
  const clientPageNumber = page + 1

  const getUrl = pageNum =>
    buildUrl(Object.assign({}, filterState, { page: pageNum }))

  const trackPage = action => {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PRODUCTS_PAGE_NEXT_SELECTED,
      eventCategory: 'Product List Page Arrows',
      eventAction: action,
    })
  }

  return (
    <div className={classNames(style.pagination, className)}>
      <div>{`${totalItems} results`}</div>
      <div className={style.control}>
        <Link
          to={`${getUrl(page - 1)}`}
          className={classNames(style.button, { [style.hidden]: firstPage })}
          aria-label={'Previous page'}
          onClick={() => trackPage('Previous')}
        >
          <Icon className={style.icon} size="small" type="arrow-left" />
        </Link>
        <div className={style.pageNumber}>{`Page ${clientPageNumber}`}</div>
        <Link
          to={`${getUrl(page + 1)}`}
          aria-label={'Next page'}
          onClick={() => trackPage('Next')}
        >
          <div
            className={classNames(style.button, { [style.hidden]: lastPage })}
          >
            <Icon className={style.icon} size="small" type="arrow-right" />
          </div>
        </Link>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  totalItems: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  className: PropTypes.string,
  filterState: PropTypes.object.isRequired,
  buildUrl: PropTypes.func,
}

export default Pagination
